export const HEADING_BASE_URL =
  process.env.REACT_APP_HEADING_BASE_URL ||
  "https://api.moneta.al/content/headingcontent";

export const FIN_HELPER_API_BASE =
  process.env.REACT_APP_FIN_HELPER_API_BASE ||
  "https://fin-helper-api.gridcoding.com";
export const CURRENTS_CARDS_URL =
  process.env.REACT_APP_CURRENTS_CARDS_URL ||
  "https://api.moneta.al/content/currentdata";
export const FEATURED_CARDS_URL =
  process.env.REACT_APP_FEATURED_CARDS_URL ||
  "https://api.moneta.al/content/featuredata";
